import { render, staticRenderFns } from "./FormTool.vue?vue&type=template&id=f389780e&"
import script from "./FormTool.vue?vue&type=script&lang=js&"
export * from "./FormTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports